import AshesRecordCard from './AshesRecordCard';

export default AshesRecordCard;
